import React from "react";

export interface BadgeProps {
  children: React.ReactNode;
  variant?:
    | "default"
    | "success"
    | "warning"
    | "error"
    | "inactive"
    | "secondary"
    | "destructive"
    | "info";
  className?: string;
  style?: React.CSSProperties;
}

export function Badge({
  children,
  variant = "default",
  className = "",
  style,
}: BadgeProps) {
  const variantClasses: Record<string, string> = {
    default:
      "bg-duvi-surface text-duvi-text-secondary border border-duvi-border",
    success:
      "bg-duvi-success/10 text-duvi-success border border-duvi-success/20",
    warning:
      "bg-duvi-warning/10 text-duvi-warning border border-duvi-warning/20",
    error:
      "bg-duvi-destructive/10 text-duvi-destructive border border-duvi-destructive/20",
    destructive:
      "bg-duvi-destructive/10 text-duvi-destructive border border-duvi-destructive/20",
    inactive:
      "bg-duvi-text-muted/10 text-duvi-text-muted border border-duvi-text-muted/20",
    secondary:
      "bg-duvi-surface text-duvi-text-secondary border border-duvi-border",
    info: "bg-duvi-accent/10 text-duvi-accent border border-duvi-accent/20",
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-[4px] ${variantClasses[variant] ?? variantClasses.default} ${className}`}
      style={{ fontSize: "var(--text-xs)", ...style }}
    >
      {children}
    </span>
  );
}
